// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3RSeN","boxTitle":"Qualiphy_boxTitle__iRZt_","box":"Qualiphy_box__2Ctd1","toggleWrap":"Qualiphy_toggleWrap__2KF9-"};